import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import PageWrapper from '../../../components/Common/PageWrapper';
import AcademyVenueTable from './Components/AcademyVenueTable';
import AddVenueModal from './Components/AddVenueModal';

interface AcademyVenueProps {}

const AcademyVenue: React.FC<AcademyVenueProps> = () => {
    const [addVenueModal, setAddVenueModal] = useState<boolean>(false);

    const handleClosed = () => {
        setAddVenueModal(false);
    }

    return (
        <PageWrapper pageTitle='Academy Venues' pageCategory='FKA' breadCrumbTitle='FKA' breadCrumbItem='Academy Venues'>
            <Row>
                <Col lg='12'>
                    <Card>
                        <CardBody>
                            <Row>
                                <div className='table-rep-plugin p-2 w-100'>
                                    <AcademyVenueTable />
                                </div>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <AddVenueModal isOpen={addVenueModal} handleClosed={handleClosed} />
            <div className='text-sm-right save-changes-button'>
                <Button
                    type='button'
                    color='primary'
                    className='btn-rounded me-1 waves-effect waves-light'
                    onClick={() => setAddVenueModal(true)}
                >
                    <i className='mdi mdi-plus me-1' />
                    Add New Venue
                </Button>
            </div>
        </PageWrapper>
    );
};

export default withRouter(AcademyVenue);
